import { createStoreAction } from '@cobuildlab/react-simple-state';
import { createPairDialogStore, deletePairDialogStore } from './pair-stores';
import { CreatePairDialogStore, DeletePairDialogStore } from './pair-types';


export const createPairDialogStoreAction = createStoreAction(createPairDialogStore, (prev, data: CreatePairDialogStore) => ({
  ...prev,
  ...data,
}));

export const deletePairDialogStoreAction = createStoreAction(deletePairDialogStore, (prev, data: DeletePairDialogStore) => ({
  ...prev,
  ...data,
}));